module.exports = {
      id: "books-vikatan-usage",
      viewBox: "0 0 22 29.5",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#books-vikatan",
      toString: function () {
        return this.url;
      }
    }